export class NotLoggedInError extends Error {}
